import { FC } from "react"
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog"
import { Button } from "../ui/button"
import { AlertTriangle } from "lucide-react"
import { useTranslation } from "@/hooks/use-translation"

interface OverwriteConfirmationDialogProps {
  open: boolean
  templateName: string
  onCancel: () => void
  onConfirm: () => void
}

export const OverwriteConfirmationDialog: FC<OverwriteConfirmationDialogProps> = ({
  open,
  templateName,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation()
  return (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onCancel() }}>
      <DialogContent className="max-w-md">
        <DialogTitle>
          <div className="flex flex-col items-center text-center space-y-6 py-4">
            <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
              <AlertTriangle className="w-8 h-8 text-red-600" />
            </div>
            <div className="">
              <p className="text-base font-medium ">
                {t("dashboard.dialogs.title.overwriteTemplateConfirmation")}
              </p>
              <p className="text-lg font-semibold mt-1">“{templateName}”?</p>
              <p className="text-sm font-medium mt-1 px-2 text-gray-500">
                {t("dashboard.dialogs.overwriteTemplateConfirmationNote")}
              </p>
            </div>
            <div className="w-full flex items-center justify-between gap-4">
              <Button variant="outline" className="flex-1" onClick={onCancel}>{t("common.cancel")}</Button>
              <Button className="flex-1 bg-slate-800 hover:bg-slate-700" onClick={onConfirm}>
                {t("dashboard.dialogs.overwrite")}
              </Button>
            </div>
          </div>
        </DialogTitle>
      </DialogContent>
    </Dialog>
  )
}

